import { render, staticRenderFns } from "./BdMainSection.vue?vue&type=template&id=d99888d8"
import script from "./BdMainSection.vue?vue&type=script&lang=js"
export * from "./BdMainSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports